import { useIntl } from 'react-intl';

import messages from '@/messages/messages';

import useFormatPrice from './useFormatPrice';

const countriesWithExclusiveTaxes = ['US', 'CA'];

const isCountryWithExclusiveTaxes = (country: string) => countriesWithExclusiveTaxes.includes(country);

export default function useFormatPricePlusApplicableTaxes() {
	const { formatMessage } = useIntl();
	const formatPrice = useFormatPrice();
	return (price: number, currency: string, country: string) => {
		const formattedPrice = formatPrice(price, currency);
		if (!isCountryWithExclusiveTaxes(country) || price === 0) {
			return formattedPrice;
		}
		return `${formattedPrice} + ${formatMessage(messages.applicableTax)}`;
	};
}
